export default __webpack_public_path__ + "static/media/gfx-e.06f02920.png";